






	import Vue from 'vue'

	function getRandom(min: number, max: number): number {
		return Math.floor(Math.random() * (max - min + 1)) + min;
	}

	export default Vue.extend({
		props: ['value'],
		data() {
			return {
				redactorId: 'vue-redactor-control-' + (getRandom(0, 10000) + Date.now()).toString(),
			}
		},
		mounted() {
			$('#'+this.redactorId).redactor({
				changeCallback: (val: string)=> {
					this.$emit('input', val)
				},
				// imageUpload: '?module=pages&action=uploadimage&filelink=1',
				// imageUploadErrorCallback: (json: any) => {
				// 	alert("Ошибка");
				// },
			});
		},
        methods: {
            updateValue: function (value: string) {
                this.$emit('input', value);
            }
        }
	});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/webpack/vue/components/Redactor.vue